module.exports = __webpack_public_path__ + "title_icon.49bb247c.png";